import React from 'react';

const LogoBars = ({ className = "w-5 h-3" }) => {
  return (
    <div className={className}>
      <svg viewBox="0 0 224 192" className="w-full h-full">
        <rect x="0" y="96" width="56" height="96" rx="28" fill="#CC457D"/>
        <rect x="84" y="48" width="56" height="144" rx="28" fill="#404880"/>
        <rect x="168" y="0" width="56" height="192" rx="28" fill="#374151"/>
      </svg>
    </div>
  );
};

export default LogoBars;